// extracted by mini-css-extract-plugin
export default {"skillsContainer":"TechnicalSkills_skillsContainer__YJZbh","skillsGrid":"TechnicalSkills_skillsGrid__xVRwf","skillCategory":"TechnicalSkills_skillCategory__OQPoX"};